import React from 'react';
import { FormControl, FormLabel, FormHelperText, TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useFormikContext } from 'formik';
import { ADVISER_FEE } from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { PREMIUM_HELP_TEXT } from '@/utils/helperText';

const AdviserFeeField = ({ loading }) => {
	const { values, setFieldValue } = useFormikContext();

	return (
		<>
			<FormControl fullWidth>
				<FormLabel>{'Current Premium'}</FormLabel>
				<NumericFormat
					customInput={TextField}
					prefix='$'
					decimalScale={0}
					fixedDecimalScale
					thousandSeparator
					allowNegative={false}
					value={values.adviserFee}
					onValueChange={({ floatValue }) => {
						setFieldValue(ADVISER_FEE, floatValue);
					}}
					disabled={loading}
					name={ADVISER_FEE}
				/>
			</FormControl>
			<FormHelperText>{PREMIUM_HELP_TEXT}</FormHelperText>
		</>
	);
};

export default AdviserFeeField;
